import { render, staticRenderFns } from "./FrontpageTop.vue?vue&type=template&id=eeced578&"
import script from "./FrontpageTop.vue?vue&type=script&lang=js&"
export * from "./FrontpageTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports